import axios from 'axios';

// const URLS = {
//   DEV: 'https://metagymdev.exbody.com:443/api/v1/po/cmn/payment/',
//   LIVE: 'https://api.pay.exbody.com:443/api/v1/nc/payment/',
//   QA: 'https://api.pay.qa.metafamily.world:443/api/v1/nc/payment/',
//   DEV_CORPORATION: 'https://metagymdev.exbody.com:443/api/v1/po/cmn/payment/',
//   LIVE_CORPORATION: 'https://api.pay.exbody.com:443/api/v1/po/ts/payment/',
//   QA_CORPORATION: 'https://api.pay.qa.metafamily.world:443/api/v1/po/ts/payment/'
// };

const URLS = {
  DEV: 'https://metagymdev.exbody.com:59889/api/v1/po/cmn/payment/',
  LIVE: 'https://api.pay.exbody.com:443/api/v1/po/cmn/payment/',
  QA: 'https://api.pay.qa.metafamily.world:443/api/v1/po/cmn/payment/',
  LOCAL: 'https://metagymdev.exbody.com:59889/api/v1/po/cmn/payment/'
  // 'http://172.16.30.24:59888/api/v1/po/cmn/payment/'
  //'http://localhost:59888/api/v1/po/cmn/payment/'
};

export const BASE_URL = window.location.origin.includes('biz.exbody.com')
  ? URLS.LIVE
  : window.location.origin.includes('qa')
  ? URLS.QA
  : window.location.origin.includes('metagymdev')
  ? URLS.DEV
  : URLS.LOCAL;

export const orderRequest = async (param: Param) => {
  const { data } = await axios.post(`${BASE_URL}registerbillingcommondispatcher`, { ...param });
  return data;
};

export const reOrderRequest = async (param: Param) => {
  const { data } = await axios.post(`${BASE_URL}execommonmanualresubscribepayment`, {
    ...param
  });
  return data;
};

export const orderCart = async (param: Param) => {
  const { data } = await axios.post(`${BASE_URL}ordercartcommondispatcher`, { ...param });
  return data;
};

export const freeOrderCart = async (param: Param) => {
  const { data } = await axios.post(`${BASE_URL}ordercartcommonwithoutpayment`, { ...param });
  return data;
};
